import UserPrefs from '@netx/core-user/models/userPrefs';

export const userPrefs = new UserPrefs();

export default userPrefs;
